import { isNotDefined } from '@sgme/fp';
import { formatDuration, type Locale } from 'date-fns';

export function getTimeSpanFormattedValue(value: Nullable<string> | undefined, locale: Locale) {
  if (isNotDefined(value)) {
    return '';
  }

  const [hours, minutes, seconds] = value.split(':').map(x => parseInt(x, 10));
  return formatDuration(
    {
      hours,
      minutes,
      seconds,
    },
    { locale },
  );
}
